export var defaultPhoneFormatter = function defaultPhoneFormatter(notFormattedPhone) {
  if (!notFormattedPhone) {
    return null;
  }
  return notFormattedPhone.replace(/\+?(\d{1})(\d{3})(\d{3})(\d{2})(\d{2}$)/, '+$1 $2 $3 $4 $5');
};